import React from 'react'
import Loading from "../components/common/Loading";
import switchStyles from "../styles/desktopMobileSwitch.module.css";
import dynamic from "next/dynamic";
import Head from "next/head";
import EwayBilling from '@/components/EwayBilling';

const eWayBilling = () => {
    return (
        <>
            <Head>
                <title>e-Way Bill Generation with QueueBuster POS, e-Way Bill Software</title>
                <link rel="canonical" href="https://queuebuster.co/features/e-way-billing" />
                <link rel="alternate" href="https://queuebuster.co/features/e-way-billing" hrefLang="en" />
                <meta name="description" content="Generate eWay Bills effortlessly with QueueBuster POS. Streamline your billing process and ensure compliance with our easy-to-use eWay Bill generation feature." />
                <meta property="og:title" content="e-Way Bill Generation with QueueBuster POS | Seamless e-Way Bill Software" />
                <meta property="og:description" content="Generate eWay Bills effortlessly with QueueBuster POS. Streamline your billing process and ensure compliance with our easy-to-use eWay Bill generation feature. Learn more today!" />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/payment-og%2B(1)+(1).jpg" />
                <meta property="og:url" content="https://queuebuster.co/features/e-way-billing" />
            </Head>
            <EwayBilling />
        </>
    )
}

export default eWayBilling